import React from 'react';
const AuthContext = React.createContext('user');
export default AuthContext;
